module.exports = __webpack_public_path__ + "img/step22_a_printer_basic_open_main_door_remove_pins.f1cdc910.png";